<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      disable-resize-watcher
      class="drawer-blur"
    >
      <div class="drawer-brand pa-5">
        <span class="drawer-mark">E</span>
        <span class="drawer-brand-text">Enrico Michael Severe</span>
      </div>
      <v-list nav dense>
        <v-list-item to="/">
          <v-list-item-icon><v-icon>mdi-home</v-icon></v-list-item-icon>
          <v-list-item-title>About</v-list-item-title>
        </v-list-item>
        <v-list-item to="/books">
          <v-list-item-icon><v-icon>mdi-book-open-page-variant</v-icon></v-list-item-icon>
          <v-list-item-title>Books</v-list-item-title>
        </v-list-item>
        <v-list-item to="/blog">
          <v-list-item-icon><v-icon>mdi-post</v-icon></v-list-item-icon>
          <v-list-item-title>Blog</v-list-item-title>
        </v-list-item>
        <v-list-item to="/scripture" class="drawer-scripture-item">
          <v-list-item-icon>
            <v-icon class="scripture-drawer-icon">mdi-book-cross</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="scripture-drawer-label">Scripture</v-list-item-title>
        </v-list-item>
        <v-list-item href="https://officialcluesofsuccess.com/guests">
          <v-list-item-icon><v-icon>mdi-star</v-icon></v-list-item-icon>
          <v-list-item-title>Clues of Success</v-list-item-title>
        </v-list-item>
        <v-list-item href="https://open.spotify.com/show/2vAdpuAPCMp5WowahRCkuu">
          <v-list-item-icon><v-icon>mdi-spotify</v-icon></v-list-item-icon>
          <v-list-item-title>Podcast</v-list-item-title>
        </v-list-item>

        <v-divider class="my-2"></v-divider>
        <div class="drawer-ventures-label">Ventures</div>

        <v-list-item href="https://benevolism.com" target="_blank" class="drawer-venture-item benevolism">
          <v-list-item-icon><v-icon>mdi-scale-balance</v-icon></v-list-item-icon>
          <v-list-item-title>Benevolism</v-list-item-title>
        </v-list-item>
        <v-list-item href="https://nextupwealthmanagement.com" target="_blank" class="drawer-venture-item nextup">
          <v-list-item-icon>
            <v-icon class="nextup-drawer-icon">mdi-chart-line</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="nextup-drawer-label">NW :: ALGO</v-list-item-title>
        </v-list-item>
        <v-list-item href="https://civilneighbr.com" target="_blank" class="drawer-venture-item civil-neighbr">
          <v-list-item-icon><v-icon>mdi-hand-heart</v-icon></v-list-item-icon>
          <v-list-item-title>Civil Neighbr</v-list-item-title>
        </v-list-item>
        <v-list-item href="https://codeforgedevelopment.com" target="_blank" class="drawer-venture-item code-forge">
          <v-list-item-icon>
            <v-icon class="cf-drawer-icon">mdi-anvil</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="cf-drawer-label">Code Forge Holdings</v-list-item-title>
        </v-list-item>
        <v-list-item href="https://thedavidicheir.com" target="_blank" class="drawer-venture-item davidic-heir">
          <v-list-item-icon><v-icon class="davidic-drawer-icon">mdi-crown</v-icon></v-list-item-icon>
          <v-list-item-title class="davidic-drawer-label">The Davidic Heir</v-list-item-title>
        </v-list-item>

        <v-divider class="my-2"></v-divider>

        <v-list-item v-if="isAuthenticated" to="/dashboard">
          <v-list-item-icon><v-icon>mdi-view-dashboard</v-icon></v-list-item-icon>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!isAuthenticated" to="/login">
          <v-list-item-icon><v-icon>mdi-login</v-icon></v-list-item-icon>
          <v-list-item-title>Login</v-list-item-title>
        </v-list-item>
        <v-list-item v-else @click="handleLogout">
          <v-list-item-icon><v-icon>mdi-logout</v-icon></v-list-item-icon>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app flat color="#0B1628" height="68" class="site-app-bar">
      <div class="brand-block d-flex align-center" @click="$router.push('/')">
        <v-img
          src="@/assets/EMS.png"
          max-width="40"
          max-height="40"
          class="rounded-lg mr-3 brand-photo"
        ></v-img>
        <v-toolbar-title class="d-none d-lg-flex brand-title">
          Enrico Michael Severe
        </v-toolbar-title>
      </div>

      <v-spacer></v-spacer>

      <div class="d-none d-md-flex align-center nav-center">
        <v-btn
          v-for="(link, i) in mainLinks"
          :key="i"
          text
          :href="link.href"
          :to="link.to"
          class="nav-btn"
        >{{ link.title }}</v-btn>

        <v-btn text to="/blog" class="nav-btn">Blog</v-btn>

        <v-btn text to="/scripture" class="nav-btn scripture-nav-btn">
          <v-icon left x-small color="#818cf8">mdi-book-cross</v-icon>
          Scripture
        </v-btn>

        <div class="nav-rule mx-2"></div>

        <div class="ventures-mega-trigger" @mouseenter="venturesOpen = true" @mouseleave="venturesOpen = false">
          <button class="ventures-trigger-btn" :class="{ active: venturesOpen }">
            <span class="ventures-trigger-text">Ventures</span>
            <span class="ventures-trigger-dots">
              <span class="vd vd--gold"></span>
              <span class="vd vd--teal"></span>
              <span class="vd vd--terracotta"></span>
              <span class="vd vd--ember"></span>
              <span class="vd vd--purple"></span>
            </span>
            <v-icon small :class="['ventures-chevron', { rotated: venturesOpen }]" color="rgba(245,240,232,0.5)">mdi-chevron-down</v-icon>
          </button>

          <transition name="mega-drop">
            <div v-if="venturesOpen" class="ventures-mega-panel">
              <div class="mega-panel-inner">

                <a href="https://benevolism.com" target="_blank" class="mega-venture-card benv-card">
                  <div class="mvc-top">
                    <div class="mvc-mark mvc-mark--gold">B</div>
                    <div class="mvc-tag">Economic Philosophy</div>
                  </div>
                  <div class="mvc-name">BENEVOLISM</div>
                  <div class="mvc-desc">Economies grow when businesses take less. The founding doctrine of a new economic order.</div>
                  <div class="mvc-link">benevolism.com ↗</div>
                </a>

                <a href="https://nextupwealthmanagement.com" target="_blank" class="mega-venture-card nextup-card">
                  <div class="mvc-top">
                    <div class="mvc-mark mvc-mark--teal">NW</div>
                    <div class="mvc-tag mvc-tag--mono">ALGO RESEARCH</div>
                  </div>
                  <div class="mvc-name mvc-name--mono">BENEVOLISM<span class="mvc-sep">::</span>ALGO</div>
                  <div class="mvc-desc">Private algorithmic research. The machine extracts. We redirect.</div>
                  <div class="mvc-link mvc-link--teal">nextupwealthmanagement.com ↗</div>
                </a>

                <a href="https://civilneighbr.com" target="_blank" class="mega-venture-card cn-card">
                  <div class="mvc-top">
                    <div class="mvc-mark mvc-mark--terra">CN</div>
                    <div class="mvc-tag">Community Platform</div>
                  </div>
                  <div class="mvc-name">CIVIL NEIGHBR</div>
                  <div class="mvc-desc">Connecting neighbors with free food, clothing, and local support in real time.</div>
                  <div class="mvc-link mvc-link--terra">civilneighbr.com ↗</div>
                </a>

                <a href="https://codeforgedevelopment.com" target="_blank" class="mega-venture-card cf-card">
                  <div class="mvc-top">
                    <div class="mvc-mark mvc-mark--ember">CF</div>
                    <div class="mvc-tag">Software Holding Company</div>
                  </div>
                  <div class="mvc-name">CODE FORGE HOLDINGS</div>
                  <div class="mvc-desc">Building and investing in software across categories — priced fairly, built to last.</div>
                  <div class="mvc-link mvc-link--ember">codeforgedevelopment.com ↗</div>
                </a>

                <a href="https://thedavidicheir.com" target="_blank" class="mega-venture-card davidic-card">
                  <div class="mvc-top">
                    <div class="mvc-mark mvc-mark--purple">♛</div>
                    <div class="mvc-tag">Scriptural Research</div>
                  </div>
                  <div class="mvc-name">THE DAVIDIC HEIR</div>
                  <div class="mvc-desc">The scriptural case that cannot be denied. Two messiahs. The argument in full.</div>
                  <div class="mvc-link mvc-link--purple">thedavidicheir.com ↗</div>
                </a>

              </div>
            </div>
          </transition>
        </div>

        <div class="nav-rule mx-2"></div>

        <v-btn
          v-if="!isAuthenticated"
          outlined
          to="/login"
          class="login-btn"
        >
          <v-icon left small>mdi-login</v-icon>
          Login
        </v-btn>

        <v-menu v-else offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="user-btn" v-bind="attrs" v-on="on">
              <v-avatar size="28" class="mr-2 user-avatar">
                <v-icon dark small>mdi-account</v-icon>
              </v-avatar>
              <span class="d-none d-lg-inline">{{ userDisplayName }}</span>
              <v-icon right small>mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item to="/dashboard">
              <v-list-item-icon><v-icon>mdi-view-dashboard</v-icon></v-list-item-icon>
              <v-list-item-title>Dashboard</v-list-item-title>
            </v-list-item>
            <v-list-item @click="handleLogout">
              <v-list-item-icon><v-icon>mdi-logout</v-icon></v-list-item-icon>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <v-app-bar-nav-icon @click="drawer = !drawer" class="d-flex d-md-none" color="#F5F0E8" />
    </v-app-bar>

    <v-main class="main-background">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </v-main>

    <v-footer color="#0B1628" padless elevation="4">
      <v-container class="text-center py-6">
        <div class="footer-ventures">
          <a href="https://benevolism.com" target="_blank" class="footer-venture-link benv">Benevolism</a>
          <span class="footer-sep">·</span>
          <a href="https://nextupwealthmanagement.com" target="_blank" class="footer-venture-link nextup">NW<span class="footer-accent">::</span>ALGO</a>
          <span class="footer-sep">·</span>
          <a href="https://civilneighbr.com" target="_blank" class="footer-venture-link cn">Civil Neighbr</a>
          <span class="footer-sep">·</span>
          <a href="https://codeforgedevelopment.com" target="_blank" class="footer-venture-link cf">Code Forge Holdings</a>
          <span class="footer-sep">·</span>
          <a href="https://thedavidicheir.com" target="_blank" class="footer-venture-link davidic">The Davidic Heir</a>
        </div>
        <div class="footer-copy">© {{ new Date().getFullYear() }} Enrico Michael Severe</div>
      </v-container>
    </v-footer>

    <v-overlay :value="loading" z-index="999">
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',
  data() {
    return {
      drawer: false,
      venturesOpen: false,
      mainLinks: [
        { title: 'About',            to: '/' },
        { title: 'Books',            to: '/books' },
        { title: 'Clues of Success', href: 'https://officialcluesofsuccess.com/guests' },
        { title: 'Podcast',          href: 'https://open.spotify.com/show/2vAdpuAPCMp5WowahRCkuu' }
      ]
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'currentUser', 'loading']),
    userDisplayName() {
      return this.currentUser?.displayName || this.currentUser?.email?.split('@')[0] || 'User'
    }
  },
  methods: {
    ...mapActions(['logout']),
    async handleLogout() {
      try {
        await this.logout()
        this.$router.push('/')
      } catch (error) {
        console.error('Logout error:', error)
      }
    }
  },
  created() {
    this.$store.dispatch('initAuth')
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Crimson+Pro:wght@400;600;700&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');

.site-app-bar {
  border-bottom: 1px solid rgba(201, 168, 76, 0.18) !important;
  overflow: visible !important;
}

.site-app-bar :deep(.v-toolbar__content) {
  overflow: visible !important;
}

.brand-block { cursor: pointer; }

.brand-photo { border: 1.5px solid rgba(201, 168, 76, 0.35); }

.brand-title {
  font-family: 'Crimson Pro', serif !important;
  font-weight: 700 !important;
  font-size: 20px !important;
  letter-spacing: -0.3px;
  color: #F5F0E8 !important;
}

.nav-center { gap: 2px; }

.nav-btn {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 13px;
  letter-spacing: 0.02em;
  text-transform: none;
  color: rgba(245, 240, 232, 0.7) !important;
  padding: 0 10px !important;
  min-width: 0 !important;
  transition: color 0.2s ease;
}

.nav-btn:hover { color: #F5F0E8 !important; background: transparent !important; }

.scripture-nav-btn {
  color: rgba(165, 180, 252, 0.82) !important;
  font-weight: 600 !important;
  text-transform: none;
  border-radius: 6px;
}
.scripture-nav-btn:hover {
  color: #a5b4fc !important;
  background: rgba(99, 102, 241, 0.1) !important;
}

.nav-rule {
  width: 1px;
  height: 20px;
  background: rgba(201, 168, 76, 0.2);
  flex-shrink: 0;
}

.ventures-mega-trigger {
  position: relative;
}

.ventures-trigger-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: transparent;
  border: none;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.2s;
  outline: none;
}

.ventures-trigger-btn:hover,
.ventures-trigger-btn.active {
  background: rgba(201, 168, 76, 0.07);
}

.ventures-trigger-text {
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: rgba(245, 240, 232, 0.7);
  letter-spacing: 0.02em;
}

.ventures-trigger-dots {
  display: flex;
  align-items: center;
  gap: 3px;
}

.vd {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}
.vd--gold     { background: #C9A84C; }
.vd--teal     { background: #00f5d4; }
.vd--terracotta { background: #D7A86E; }
.vd--ember    { background: #ff7a45; }
.vd--purple   { background: #c4b5fd; }

.ventures-chevron {
  transition: transform 0.25s ease;
}
.ventures-chevron.rotated {
  transform: rotate(180deg);
}

.ventures-mega-panel {
  position: absolute;
  top: calc(100% + 12px);
  right: -20px;
  width: 680px;
  background: #0d1830;
  border: 0.5px solid rgba(201, 168, 76, 0.2);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.6);
  z-index: 1000;
  border-radius: 4px;
  overflow: hidden;
}

.mega-panel-inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
}

.mega-venture-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 22px 24px;
  text-decoration: none;
  border-right: 0.5px solid rgba(255, 255, 255, 0.05);
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.05);
  transition: background 0.2s;
}

.mega-venture-card:nth-child(2),
.mega-venture-card:nth-child(4) { border-right: none; }

.mega-venture-card:nth-child(3),
.mega-venture-card:nth-child(4) { border-bottom: none; }

.cf-card { grid-column: 1 / -1; border-right: none; border-bottom: none; }

.benv-card:hover     { background: rgba(201, 168, 76, 0.05); }
.nextup-card:hover   { background: rgba(0, 245, 212, 0.04); }
.cn-card:hover       { background: rgba(215, 168, 110, 0.05); }
.davidic-card:hover  { background: rgba(139, 92, 246, 0.05); }

.mvc-top {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}

.mvc-mark {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13px;
  flex-shrink: 0;
  font-family: 'Inter', sans-serif;
}

.mvc-mark--gold   { background: rgba(201,168,76,0.15); color: #C9A84C; border: 0.5px solid rgba(201,168,76,0.3); }
.mvc-mark--teal   { background: rgba(0,245,212,0.1); color: #00f5d4; border: 0.5px solid rgba(0,245,212,0.25); font-family: 'JetBrains Mono', monospace; font-size: 10px; }
.mvc-mark--terra  { background: rgba(215,168,110,0.15); color: #D7A86E; border: 0.5px solid rgba(215,168,110,0.3); }
.mvc-mark--ember  { background: rgba(255,122,69,0.14); color: #ff7a45; border: 0.5px solid rgba(255,122,69,0.3); }
.mvc-mark--purple { background: rgba(139,92,246,0.12); color: #c4b5fd; border: 0.5px solid rgba(139,92,246,0.25); font-size: 16px; }

.mvc-tag {
  font-family: 'Inter', sans-serif;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(245, 240, 232, 0.3);
}

.mvc-tag--mono {
  font-family: 'JetBrains Mono', monospace;
  color: rgba(0, 245, 212, 0.4);
}

.mvc-name {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: rgba(245, 240, 232, 0.9);
}

.mvc-name--mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: #00f5d4;
  letter-spacing: 0.08em;
}

.mvc-sep { color: rgba(0, 245, 212, 0.4); }

.mvc-desc {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  line-height: 1.6;
  color: rgba(245, 240, 232, 0.45);
  font-weight: 300;
  flex: 1;
}

.mvc-link {
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: rgba(201, 168, 76, 0.6);
  letter-spacing: 0.04em;
  margin-top: 4px;
  transition: color 0.2s;
}

.benv-card:hover .mvc-link     { color: #C9A84C; }
.mvc-link--teal   { color: rgba(0, 245, 212, 0.5); }
.nextup-card:hover .mvc-link   { color: #00f5d4; }
.mvc-link--terra  { color: rgba(215, 168, 110, 0.6); }
.cn-card:hover .mvc-link       { color: #D7A86E; }
.mvc-link--ember  { color: rgba(255, 122, 69, 0.6); }
.cf-card:hover .mvc-link       { color: #ff7a45; }
.mvc-link--purple { color: rgba(196, 181, 253, 0.6); }
.davidic-card:hover .mvc-link  { color: #c4b5fd; }

.mega-drop-enter-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}
.mega-drop-leave-active {
  transition: opacity 0.14s ease, transform 0.14s ease;
}
.mega-drop-enter,
.mega-drop-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.login-btn {
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.04em;
  text-transform: none;
  border-radius: 6px;
  color: #F5F0E8 !important;
  border: 1px solid rgba(245, 240, 232, 0.25) !important;
  transition: all 0.25s ease;
}
.login-btn:hover { border-color: #C9A84C !important; color: #C9A84C !important; }

.user-btn {
  text-transform: none;
  border-radius: 24px;
  font-weight: 600;
  background: rgba(201, 168, 76, 0.12) !important;
  color: #F5F0E8 !important;
  box-shadow: none !important;
  font-size: 13px;
}
.user-avatar { background: #C9A84C !important; }

.drawer-blur {
  backdrop-filter: blur(12px);
  background-color: rgba(255, 255, 255, 0.97);
}

.drawer-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid rgba(26, 26, 46, 0.08);
}

.drawer-mark {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #1a1a2e;
  color: #C9A84C;
  font-family: 'Crimson Pro', serif;
  font-weight: 700;
  font-size: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.drawer-brand-text {
  font-family: 'Crimson Pro', serif;
  font-weight: 700;
  font-size: 15px;
  color: #1a1a2e;
}

.drawer-scripture-item :deep(.v-icon),
.scripture-drawer-icon { color: #6366f1 !important; }
.scripture-drawer-label { color: #6366f1 !important; font-weight: 600 !important; }
.cf-drawer-icon { color: #ff7a45 !important; }
.cf-drawer-label { color: #ff7a45 !important; font-weight: 600 !important; }
.davidic-drawer-icon { color: #8b5cf6 !important; }
.davidic-drawer-label { color: #8b5cf6 !important; font-weight: 600 !important; }
.nextup-drawer-icon { color: #00f5d4 !important; }
.nextup-drawer-label {
  color: #00f5d4 !important;
  font-weight: 600 !important;
  font-family: 'JetBrains Mono', monospace !important;
  font-size: 12px !important;
  letter-spacing: 0.06em !important;
}

.drawer-ventures-label {
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #9ca3af;
  padding: 8px 16px 4px;
}

.drawer-venture-item.benevolism :deep(.v-icon) { color: #C9A84C; }
.drawer-venture-item.civil-neighbr :deep(.v-icon) { color: #D7A86E; }

.main-background { background: #0d1117; min-height: 100vh; }

.fade-enter-active, .fade-leave-active { transition: opacity 0.3s ease; }
.fade-enter, .fade-leave-to { opacity: 0; }

.footer-ventures {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.footer-venture-link {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  letter-spacing: 0.04em;
  transition: opacity 0.2s;
}
.footer-venture-link:hover { opacity: 0.7; }
.footer-venture-link.benv    { color: #C9A84C; }
.footer-venture-link.nextup  { font-family: 'JetBrains Mono', monospace; font-size: 11px; color: #00f5d4; letter-spacing: 0.1em; }
.footer-accent { color: rgba(0, 245, 212, 0.45); }
.footer-venture-link.cn      { color: #D7A86E; }
.footer-venture-link.cf      { color: #ff7a45; }
.footer-venture-link.davidic { color: #c4b5fd; }
.footer-sep { color: rgba(245, 240, 232, 0.18); font-size: 12px; }
.footer-copy { font-family: 'Inter', sans-serif; font-size: 12px; color: rgba(245, 240, 232, 0.28); letter-spacing: 0.04em; }

@media (max-width: 960px) {
  .brand-title { font-size: 17px !important; }
}
</style>